<template>
  <div class="flex items-center justify-center min-h-[400px]">
    <el-card class="w-[400px] shadow-lg rounded-lg border-none">
      <template #header>
        <div class="text-center">
          <h2 class="text-xl font-bold text-gray-700">系统访问</h2>
          <p class="text-sm text-gray-400 mt-1">请输入访问口令以继续</p>
        </div>
      </template>
      <el-form :model="form" @submit.prevent="handleSubmit">
        <el-form-item>
          <el-input
            v-model="form.token"
            type="password"
            placeholder="访问口令"
            show-password
            size="large"
            :prefix-icon="Lock"
            @keyup.enter="handleSubmit"
          />
        </el-form-item>
        <el-form-item class="mb-0">
          <el-button
            type="primary"
            class="w-full"
            size="large"
            :loading="loading"
            @click="handleSubmit"
          >
            进入系统
          </el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script setup lang="ts">
import { ref, reactive } from "vue";
import { Lock } from "@element-plus/icons-vue";
import { verifyToken } from "../api/envApi";
import { ElMessage } from "element-plus";

const emit = defineEmits<{
  (e: "success", token: string): void;
}>();

const loading = ref(false);
const form = reactive({
  token: "",
});

const handleSubmit = async () => {
  if (!form.token) {
    ElMessage.warning("请输入口令");
    return;
  }

  loading.value = true;
  try {
    const data = await verifyToken(form.token);
    ElMessage.success("验证成功");
    emit("success", data.auth);
  } catch (error: any) {
    ElMessage.error(error || "验证失败，口令错误");
  } finally {
    loading.value = false;
  }
};
</script>

<style scoped>
:deep(.el-card__header) {
  padding-bottom: 0;
  border-bottom: none;
}
</style>
